import { environment } from './utils/constants';

const IS_PRODUCTION = process.env.NODE_ENV === 'production';

const IS_DEVELOPMENT = process.env.NODE_ENV === 'development';

const _dwb_env_ = (window as any)._dossier_workbench_env_;

let BACKEND_URL = "";

let ELDA_URL = "";

if(window.location.host.includes("endurance") || window.location.host.includes("batavia") || window.location.host.includes("localhost")) {
    BACKEND_URL = environment.backendUrl;
    ELDA_URL = environment.eldaUrl;
}

if(window.location.host.includes("lod.apps")) {
    BACKEND_URL = environment.backendExternalUrl;
    ELDA_URL = environment.eldaExternalUrl;
}

if(window.location.host.includes("data-np.epo.org") || window.location.host.includes("data.epo.org") || window.location.host.includes("pilot-data.epo.org")){
    BACKEND_URL = environment.backendExternalUrlData;
    ELDA_URL = environment.eldaExternalUrlData;
}

const PUBLIC_URL = _dwb_env_ ? _dwb_env_.REACT_APP_PUBLIC_URL : process.env.PUBLIC_URL;

const DEV_TOKEN = process.env.REACT_APP_DEV_TOKEN;

export { PUBLIC_URL, BACKEND_URL, ELDA_URL, IS_PRODUCTION, IS_DEVELOPMENT, DEV_TOKEN };
